import { useState, useEffect, useCallback } from 'react';
import qs from 'query-string';
import Immutable from 'immutable';
import { useHistory, useLocation } from 'react-router';

import config from 'react-global-configuration';

import fromJSOrdered from '../../../helpers/fromJsOrdered';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

const useQueryParameter = (param, defaultValue = '') => {
  const location = useLocation();
  const [queryParams, setQueryParams] = useState(defaultValue);
  const query = qs.parse(location.search);
  useEffect(() => {
    if (typeof query[param] !== 'undefined') {
      setQueryParams(query[param]);
    }
  }, [query, param]);

  return queryParams;
};

const useSearchApi = (searchIndex, searchPage = '/search', language = DEFAULT_LANGUAGE) => {
  const history = useHistory();
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(Immutable.Map());

  const currentQuery = useQueryParameter('q', '');
  const currentYear = useQueryParameter('filter[field_year]', new Date().getFullYear() - 1);
  const currentPage = useQueryParameter('page', 0);
  const API_URL = config.get('API_URL');
  const downloadUrl = `${API_URL}/companies/export?q=${currentQuery}&year=${currentYear}`;

  useEffect(() => {
    // Prevent search from being executed twice on startup.
    if (!initialized) {
      setInitialized(true);
      return;
    }

    setLoading(true);

    fetch(`${API_URL}/${language}/search_api/${searchIndex}/search?filter[fulltext]=${currentQuery}&filter[field_year]=${currentYear}&page=${currentPage}&count=30&sort=title&order=ASC`)
      .then((response) => response.json())
      .then((json) => {
        return fromJSOrdered(json);
      })
      .then((response) => {
        setLoading(false);
        setResults(Immutable.fromJS(response));
      })
      .catch((error) => {
        setLoading(false);
        setResults(Immutable.fromJS([]));
      });
  }, [searchIndex, currentQuery, currentYear, currentPage, initialized, language, API_URL]);

  const doSearch = useCallback((_query, _year, _page) => {
    history.push({
      pathname: searchPage,
      search: `?q=${_query}&filter[field_year]=${_year}&page=${_page}&count=30`,
    });
  }, [history, searchPage]);

  return [
    results,
    currentQuery,
    currentYear,
    loading,
    downloadUrl,
    doSearch,
  ];
};

export default useSearchApi;
